export default "__VITE_ASSET__BUirmA5S__"